import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import SelectUser from "./pages/SelectUser";
import Login from "./pages/Login";
import ChildHome from "./pages/ChildHome";
import ParentHome from "./pages/ParentHome";
import ChildShop from "./pages/ChildShop";
import ChildProfile from "./pages/ChildProfile";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SelectUser />} />
        <Route path="/login" element={<Login />} />
        <Route path="/child" element={<ChildHome />} />
        <Route path="/parent" element={<ParentHome />} />
        <Route path="/child-shop" element={<ChildShop />} />
        <Route path="/child-profile" element={<ChildProfile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
